const localStorageHelper = (id) => {
  const value = localStorage.getItem(id)
  let localStorageValue = value

  // One parse, and no Object.keys on the raw string: a federation's stored org embeds all its
  // teams (~120 KB), and this runs in every permission check.
  try {
    localStorageValue = JSON.parse(value || '""')
  } catch {
    // Not JSON: keep the raw string.
  }

  const setLocalStorageValue = (data) => {
    localStorage.setItem(id, JSON.stringify(data))
    window.dispatchEvent(new Event('storage'))
  }

  const removeLocalStorageValue = () => {
    localStorage.removeItem(id)
  }

  return {
    localStorageValue,
    setLocalStorageValue,
    removeLocalStorageValue,
  }
}

export default localStorageHelper
